import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	header: {
		background: theme.palette.background.header,
		boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.15)",
		height: 96,
		left: 0,
		position: "fixed",
		right: 0,
		top: 0,
		zIndex: theme.zIndex.appBar
	},
	container: {
		alignItems: "center",
		display: "flex",
		height: "100%",
		[theme.breakpoints.down("sm")]: {
			justifyContent: "space-between"
		},
		[theme.breakpoints.up("md")]: {
			gap: theme.spacing(3)
		},
		[theme.breakpoints.up("lg")]: {
			gap: theme.spacing(6)
		}
	},
	contactIcons: {
		alignItems: "center",
		display: "flex",
		[theme.breakpoints.up("md")]: {
			marginLeft: "auto"
		},
		"& a": {
			alignItems: "center",
			display: "flex",
			fontWeight: 700,
			gap: theme.spacing(1.5),
			padding: theme.spacing(1.5),
			"& img": {
				display: "block"
			}
		}
	},
	phoneLabel: {
		display: "flex",
		gap: theme.spacing(0.5),
		[theme.breakpoints.down("md")]: {
			display: "none"
		}
	}
}));

export default styles;
